import React from 'react'
import ProductDetails from './ProductDetails'
import { useDispatch, useSelector } from 'react-redux'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { selectTag, selectTagProduct } from '../actions/digitalMenuActions'

const TagProductDetails = (props) => {

  const dispatch = useDispatch()
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)
  const tag = props.match.params[1]
  const product = useSelector(loadMenuDataSelectors.getTagProduct(props.match.params[1], props.match.params[2]))
  const nextProduct = useSelector(loadMenuDataSelectors.getTagNextProduct(props.match.params[1], props.match.params[2]))
  const previousProduct = useSelector(loadMenuDataSelectors.getTagPreviousProduct(props.match.params[1], props.match.params[2]))

  const handleProductClick = (product) => {
    return product != null ? () => {
      dispatch(selectTagProduct(tag, product, storeCode))
    } : null
  }

  const handleBackButtonClick = () => {
    dispatch(selectTag(tag, storeCode))
  }

  return <ProductDetails
    product={product}
    handleNextProductClick={handleProductClick(nextProduct)}
    handlePreviousProductClick={handleProductClick(previousProduct)}
    handleBackButtonClick={handleBackButtonClick}
    {...props}
  />
}

export default TagProductDetails
